import { FooterConsent } from './FooterConsent';

export default FooterConsent;
